import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import CodeIcon from "@mui/icons-material/Code";
import MapsUgcOutlinedIcon from "@mui/icons-material/MapsUgcOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import PersonRemoveAlt1Outlined from "@mui/icons-material/PersonRemoveAlt1Outlined";

const CustomButton = styled(Button)(({ theme }) => ({
  borderRadius: "20px",
  color: "#ffffff",
  fontSize: "12px",

  fillRule: "evenodd",
  textTransform: "none",
  backgroundColor: "rgba(255,255,255,0.09803921568627451 )",
  padding: "0px",
  paddingRight: "10px",
  paddingLeft: "10px",
  "&:hover": {
    backgroundColor: "#36899f",
    boxShadow: "none",
  },
  boxShadow: "none",
}));

const GlobalButton = styled(CustomButton)(({ theme }) => ({
  background: "rgba(255,255,255,0.09803921568627451 )",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.09803921568627451 )",
  },
}));

const YellowButton = styled(CustomButton)(({ theme }) => ({
  background: "#ddb930",
  "&:hover": {
    backgroundColor: "#ddb930",
  },
}));

const SkyButton = styled(CustomButton)(({ theme }) => ({
  background: "#36899f",
  "&:hover": {
    backgroundColor: "#36899f",
  },
}));

interface smallIconButtonProps {
  color: string;
  text: string;
  size?: string;
  type: string;
  img?: string;
  isClicked: boolean;
}

const SmallIconButton: React.FC<smallIconButtonProps> = ({
  color,
  text,
  size,
  type,
  img,
  isClicked,
}) => {

  const tickets = require("assets/ticket.png");

  return color === "yellow" && isClicked === true ? (
    type === "avatar" ? (
      <YellowButton
        variant="contained"
        startIcon={
          <img
            src={img}
            style={{ width: "20px", height: "20px" }}
            alt={"img"}
          />
        }
        style={{
          paddingRight: "10px",
          paddingTop: "5px",
          paddingBottom: "5px",
        }}
      >
        {text}
      </YellowButton>
    ) : type === "play" ? (
      <YellowButton
        variant="contained"
        startIcon={
          <img
            src={img}
            style={{ width: "10px", height: "10px" }}
            alt={"img"}
          />
        }
        style={{
          paddingLeft: "12px",
          paddingTop: "5px",
          paddingBottom: "5px",
        }}
      >
        {text}
      </YellowButton>
    ) : type === "dev" ? (
      <YellowButton variant="contained" startIcon={<CodeIcon />}>
        {text}
      </YellowButton>
    ) : type === "contact" ? (
      <YellowButton
        variant="contained"
        startIcon={<MapsUgcOutlinedIcon style={{ fontSize: "15px" }} />}
      >
        {text}
      </YellowButton>
    ) : type === "follow" ? (
      <YellowButton
        variant="contained"
        startIcon={<PersonAddAltOutlinedIcon style={{ fontSize: "15px" }} />}
      >
        {text}
      </YellowButton>
    ) : type === "following" ? (
      <YellowButton
        variant="contained"
        startIcon={<PersonRemoveAlt1Outlined style={{ fontSize: "15px" }} />}
      >
        {text}
      </YellowButton>
    ) : type === "ticket" ? (
      <YellowButton
        variant="contained"
        startIcon={<img src={tickets} alt={"img"}/>}
      >
        {text}
      </YellowButton>
    ) : (
      <YellowButton variant="contained">{text}</YellowButton>
    )
  ) : color === "sky" && isClicked === true ? (
    type === "avatar" ? (
      <SkyButton
        variant="contained"
        startIcon={
          <img
            src={img}
            style={{ width: "20px", height: "20px" }}
            alt={"img"}
          />
        }
        style={{
          paddingRight: "10px",
          paddingTop: "5px",
          paddingBottom: "5px",
        }}
      >
        {text}
      </SkyButton>
    ) : type === "coder" ? (
      <SkyButton variant="contained" startIcon={<CodeIcon />}>
        {text}
      </SkyButton>
    ) : type === "contact" ? (
      <SkyButton
        variant="contained"
        startIcon={<MapsUgcOutlinedIcon style={{ fontSize: "15px" }} />}
      >
        {text}
      </SkyButton>
    ) : type === "follow" ? (
      <SkyButton
        variant="contained"
        startIcon={<PersonAddAltOutlinedIcon style={{ fontSize: "15px" }} />}
      >
        {text}
      </SkyButton>
    ) : type === "following" ? (
      <SkyButton
        variant="contained"
        startIcon={<PersonRemoveAlt1Outlined style={{ fontSize: "15px" }} />}
      >
        {text}
      </SkyButton>
    ) : (
      <SkyButton variant="contained">{text}</SkyButton>
    )
  ) : color === "none" && isClicked === true ? (
    type === "avatar" ? (
      <GlobalButton
        variant="contained"
        startIcon={
          <img
            src={img}
            style={{ width: "20px", height: "20px" }}
            alt={"img"}
          />
        }
        style={{
          paddingRight: "10px",
          paddingTop: "5px",
          paddingBottom: "5px",
        }}
      >
        {text}
      </GlobalButton>
    ) : type === "coder" ? (
      <GlobalButton variant="contained" startIcon={<CodeIcon />}>
        {text}
      </GlobalButton>
    ) : type === "contact" ? (
      <GlobalButton
        variant="contained"
        startIcon={<MapsUgcOutlinedIcon style={{ fontSize: "15px" }} />}
      >
        {text}
      </GlobalButton>
    ) : type === "follow" ? (
      <GlobalButton
        variant="contained"
        startIcon={<PersonAddAltOutlinedIcon style={{ fontSize: "15px" }} />}
      >
        {text}
      </GlobalButton>
    ) : (
      <GlobalButton variant="contained">{text}</GlobalButton>
    )
  ) : (
    <GlobalButton variant="contained">{text}</GlobalButton>
  );
};

export default SmallIconButton;
